export class UpfrontIncentive {
	name?: string;
	value: number;
}
